import React from 'react';
import { Box } from '@mui/material';

const AudioFirstNotePrompt: React.FC = () => (
  <Box
    role="status"
    data-audio-first-note-prompt
    sx={{
      position: 'absolute',
      top: 'calc(58px + env(safe-area-inset-top, 0px))',
      left: '50%',
      zIndex: 2200,
      maxWidth: 'min(520px, calc(100vw - 32px))',
      transform: 'translateX(-50%)',
      border: '1px solid rgba(121, 216, 255, 0.38)',
      borderRadius: '999px',
      backgroundColor: 'rgba(5, 11, 19, 0.94)',
      boxShadow: '0 10px 28px rgba(0, 0, 0, 0.28)',
      color: '#F2F6FF',
      px: '18px',
      py: '9px',
      fontFamily: 'Lato, sans-serif',
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: 1.35,
      textAlign: 'center',
      pointerEvents: 'none',
    }}
  >
    Listening for your piano. Play the highlighted note to begin.
  </Box>
);

export default AudioFirstNotePrompt;
